


















































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import Profile from '@/connector/Profile.vue';
import DialogConnector from '@/connector/Dialog.vue';

@Component({
  components: {
    Profile,
    DialogConnector,
  },
})
export default class ProfileDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  get dialog() {
    return this.open;
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  public async copyUfaAccount(id: string) {
    const copyText = document.getElementById(id);
    if (copyText) {
      const value = copyText?.innerText;
      window.navigator.clipboard.writeText(value);
      this.$store.commit('Snackbar/showNotification', { message: 'คัดลอกเลขบัญชีufaแล้ว', error: false });
    }
  }
}
